import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

export interface MinimumQuestionsDialogData {
  methodologyName: string;
  added: string[];
  removed: string[];
}

@Component({
  selector: 'app-minimum-questions-dialog',
  templateUrl: './minimum-questions-dialog.component.html',
  styleUrls: ['./minimum-questions-dialog.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class MinimumQuestionsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MinimumQuestionsDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: MinimumQuestionsDialogData,
  ) {}
}
